export const pinstripe = [
  {
    number: 'PS100',
    hasModel: true,
  },
  {
    number: 'PS101',
    hasModel: true,
  },
  {
    number: 'PS102',
    hasModel: true,
  },
  {
    number: 'PS103',
    hasModel: false,
  },
  {
    number: 'PS104',
    hasModel: true,
  },
  {
    number: 'PS105',
    hasModel: true,
  },
  {
    number: 'PS106',
    hasModel: true,
  },
  {
    number: 'PS107',
    hasModel: true,
  },
  {
    number: 'PS108',
    hasModel: false,
  },
  {
    number: 'PS109',
    hasModel: false,
  },
  {
    number: 'PS110',
    hasModel: false,
  },
  {
    number: 'PS111',
    hasModel: false,
  },
  {
    number: 'PS112',
    hasModel: false,
  },
  {
    number: 'PS113',
    hasModel: true,
  },
  {
    number: 'PS114',
    hasModel: true,
  },
  {
    number: 'PS115',
    hasModel: true,
  },
  {
    number: 'PS116',
    hasModel: false,
  },
  {
    number: 'PS117',
    hasModel: false,
  },
  {
    number: 'PS118',
    hasModel: false,
  },
  {
    number: 'PS119',
    hasModel: true,
  },
  {
    number: 'PS120',
    hasModel: false,
  },
  {
    number: 'PS121',
    hasModel: false,
  },
  {
    number: 'PS122',
    hasModel: false,
  },
  {
    number: 'PS123',
    hasModel: false,
  },
  {
    number: 'PS124',
    hasModel: false,
  },
  {
    number: 'PS125',
    hasModel: false,
  },
  {
    number: 'PSX',
    hasModel: false,
  },
];
